import * as React from "react";
const SvgFiRrO = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12.022 24c-5.515 0-10-4.486-10-10v-4c.503-13.251 19.5-13.241 20 0v4c0 5.514-4.486 10-10 10m0-22c-4.412 0-8 3.589-8 8v4c.376 10.59 15.626 10.583 16 0v-4c0-4.411-3.59-8-8-8"
    />
  </svg>
);
export default SvgFiRrO;
